import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Zap, ArrowLeft } from 'lucide-react';

const CGUPage = () => {
  return (
    <div style={{backgroundColor: '#F7F8FA', color: '#1e293b'}} className="min-h-screen">
      {/* Navigation */}
      <nav style={{backgroundColor: '#ffffff'}} className="border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <span style={{color: '#1e293b'}} className="text-xl font-bold">SmartFacture AI</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" style={{color: '#475569'}}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 style={{color: '#1e293b'}} className="text-3xl font-bold mb-8">Conditions Générales d'Utilisation (CGU)</h1>
        
        <div style={{backgroundColor: '#ffffff'}} className="rounded-2xl p-8 shadow-sm space-y-8">
          
          {/* Informations légales */}
          <section className="p-4 bg-slate-50 border border-slate-200 rounded-lg mb-6">
            <h2 style={{color: '#1e293b'}} className="text-lg font-semibold mb-3">Informations légales</h2>
            <div style={{color: '#475569'}} className="space-y-1 text-sm">
              <p><strong>Dénomination commerciale :</strong> SmartFacture</p>
              <p><strong>Responsable :</strong> Mr Bouhyana Mustapha</p>
              <p><strong>Email de contact :</strong> <a href="mailto:tigroo93@hotmail.fr" className="text-blue-600 hover:underline">tigroo93@hotmail.fr</a></p>
              <p><strong>SIREN :</strong> 889 445 789</p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 1 - Objet</h2>
            <p style={{color: '#475569'}}>
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités 
              d'accès et d'utilisation du service SmartFacture, accessible à l'adresse https://smartfacture-ai.com.
              En utilisant ce service, vous acceptez sans réserve les présentes CGU.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 2 - Description du service</h2>
            <p style={{color: '#475569'}}>
              SmartFacture AI est un logiciel de facturation électronique en mode SaaS (Software as a Service) 
              permettant de créer, gérer et exporter des factures conformes à la réforme française de facturation 
              électronique 2026. Le service inclut notamment :
            </p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li>Création de factures au format Factur-X (PDF/A-3 + XML)</li>
              <li>Scanner IA pour numériser des documents</li>
              <li>Simulation de conformité PPF/PDP</li>
              <li>Export et gestion des factures</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 3 - Accès au service</h2>
            <p style={{color: '#475569'}}>
              L'accès au service nécessite la création d'un compte utilisateur. L'utilisateur s'engage à fournir 
              des informations exactes et à maintenir la confidentialité de ses identifiants de connexion.
              SmartFacture AI se réserve le droit de suspendre ou supprimer tout compte en cas de non-respect des CGU.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 4 - Essai gratuit et abonnements</h2>
            <div style={{color: '#475569'}} className="space-y-2">
              <p><strong>Essai gratuit :</strong> Tout nouvel utilisateur bénéficie d'un essai gratuit de 7 jours 
              et de 10 actions (création de facture, scan, simulation, export). Aucune carte bancaire n'est requise. 
              L'essai peut être annulé à tout moment pendant la période d'essai.</p>
              <p><strong>Abonnements payants :</strong> Au-delà de l'essai gratuit, l'utilisation du service 
              nécessite un abonnement payant. Les tarifs sont indiqués sur la page Tarifs.</p>
              <p><strong>Résiliation :</strong> L'utilisateur peut résilier son abonnement à tout moment depuis son espace client. 
              La résiliation prend effet à la fin de la période de facturation en cours.</p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 4 bis - Politique de non-remboursement</h2>
            <div style={{color: '#475569'}} className="space-y-2">
              <p><strong>Essai gratuit disponible pour découvrir SmartFacture.</strong></p>
              <p>Scannez simplement vos documents : notre intelligence artificielle extrait, classe et génère 
              automatiquement vos factures et données comptables. Aucune configuration complexe, aucune saisie manuelle.</p>
              <p>L'activation d'un abonnement donne un accès immédiat à l'ensemble des fonctionnalités professionnelles.</p>
              <p><strong>Conformément à la réglementation applicable aux services numériques, aucun remboursement, 
              total ou partiel, ne pourra être accordé après activation, utilisation du service ou génération de documents.</strong></p>
              <p>Tout abonnement activé est dû. SmartFacture est un service numérique automatisé à valeur immédiate.</p>
              <p>Cette politique garantit un service sécurisé, équitable et sans abus pour l'ensemble des utilisateurs.</p>
              <p className="mt-3">Besoin d'aide avant de vous engager ? Notre équipe est disponible pour vous accompagner 
              via <a href="mailto:support@smartfacture-ai.com" className="text-blue-600 hover:underline">support@smartfacture-ai.com</a>.</p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 5 - Obligations de l'utilisateur</h2>
            <p style={{color: '#475569'}}>L'utilisateur s'engage à :</p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li>Utiliser le service conformément à sa destination et aux lois en vigueur</li>
              <li>Ne pas tenter d'accéder aux systèmes informatiques de SmartFacture AI de manière non autorisée</li>
              <li>Ne pas utiliser le service à des fins illicites ou frauduleuses</li>
              <li>Vérifier l'exactitude des factures générées avant tout envoi</li>
              <li>Respecter les obligations légales relatives à la facturation</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 6 - Responsabilité</h2>
            <div style={{color: '#475569'}} className="space-y-2">
              <p><strong>SmartFacture AI :</strong> Le service est fourni "en l'état". SmartFacture AI s'efforce 
              d'assurer la disponibilité et le bon fonctionnement du service mais ne peut garantir une disponibilité 
              à 100%. SmartFacture AI ne saurait être tenu responsable des dommages indirects résultant de l'utilisation 
              ou de l'impossibilité d'utiliser le service.</p>
              <p><strong>Utilisateur :</strong> L'utilisateur est seul responsable de l'utilisation qu'il fait du service 
              et des données qu'il y saisit. Il lui appartient de vérifier la conformité des documents générés 
              avec la réglementation applicable.</p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 7 - Propriété intellectuelle</h2>
            <p style={{color: '#475569'}}>
              SmartFacture AI conserve l'intégralité des droits de propriété intellectuelle sur le service, 
              son interface, ses fonctionnalités et sa documentation. L'utilisateur bénéficie d'une licence 
              d'utilisation non exclusive, personnelle et non transférable pour la durée de son abonnement.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 8 - Données personnelles</h2>
            <p style={{color: '#475569'}}>
              Le traitement des données personnelles est détaillé dans notre{' '}
              <Link to="/confidentialite" className="text-blue-600 hover:underline">Politique de Confidentialité</Link>.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 9 - Modification des CGU</h2>
            <p style={{color: '#475569'}}>
              SmartFacture AI se réserve le droit de modifier les présentes CGU à tout moment. 
              Les utilisateurs seront informés des modifications par email ou notification sur le service.
              La poursuite de l'utilisation du service après modification vaut acceptation des nouvelles CGU.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">Article 10 - Droit applicable et litiges</h2>
            <p style={{color: '#475569'}}>
              Les présentes CGU sont régies par le droit français. En cas de litige relatif à l'interprétation 
              ou l'exécution des présentes, les parties s'efforceront de trouver une solution amiable. 
              À défaut, les tribunaux français seront seuls compétents.
            </p>
          </section>

          <p style={{color: '#94a3b8'}} className="text-sm mt-8">
            Dernière mise à jour : Février 2026
          </p>
        </div>
      </main>
    </div>
  );
};

export default CGUPage;
